import * as ng from "@angular/core";
import {CanActivate} from "@angular/router";
import {Mag2LocalStorage} from "../../lib/mag2-local-storage";

@ng.Injectable()
export class ExistClientIdGuard implements CanActivate {

  canActivate() {
    if (Mag2LocalStorage.getClientId() === null) {
      Mag2LocalStorage.setClientId(ExistClientIdGuard.generateUUID());
    }

    return true;
  }

  /**
   * @see [[https://github.com/GoogleChrome/chrome-platform-analytics/blob/master/src/internal/identifier.js]]
   */
  private static generateUUID() {
    let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
    for (let i = 0, len = chars.length; i < len; i++) {
      switch (chars[i]) {
        case "x":
          chars[i] = Math.floor(Math.random() * 16).toString(16);
          break;
        case "y":
          chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
          break;
      }
    }
    return chars.join("").toUpperCase();
  }
}
